import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { toFormData } from '../../utils/toFormData';
import { logError } from '../../utils/logError';
import {
    ResetPasswordError,
    ResetPasswordErrorMessage,
    ResetPasswordPayload,
    ResetPasswordResponse,
    ResetPasswordResult,
} from './resetPassword.types';

const mapMessagesToKeys = (message: ResetPasswordErrorMessage): ResetPasswordError => {
    switch (message) {
        case 'The email address you entered could not be found.':
            return 'not_found';
        default:
            return 'unspecified';
    }
};

export const resetPassword = async ({ email, funnel }: ResetPasswordPayload): Promise<ResetPasswordResult> => {
    try {
        const url = pathfinder('password_resets');
        const formData = toFormData({ email, funnel });

        const { data } = await axios.post<ResetPasswordResponse>(url, formData);

        return {
            status: data.status,
            redirectUrl: data.redirect_url,
            ...(data.message && { message: mapMessagesToKeys(data.message) }),
        };
    } catch (error) {
        logError({
            error,
            message: 'Error during reset password',
        });

        return {
            status: 'failure',
            message: 'unspecified',
        };
    }
};
